module.exports = __webpack_public_path__ + "img/Bilder_Website_Shop.e5890eb3.png";